import { localStorage } from '@/utils/local-storage';

export interface CourtSnapshot<TMatch> {
  match: TMatch;
  clocks: Record<string, { valueAtAnchor: number; anchorAt: number | null }>;
}

export const courtSnapshot = <TMatch>() =>
  localStorage<CourtSnapshot<TMatch> | undefined>('court-match', undefined);
